export const alphabet = "абвгдежзийклмнопрстуфхцчшщъыьэюя".split("");

export const filterByLetter = (letter,listCities,setFiltered) => {
    const filtered = listCities?.filter(
      (city) => city?.name && city.name.toLowerCase().startsWith(letter.toLowerCase())
    );
    setFiltered(filtered);
  };
